import DocsPage from "@/pages/docs/DocsPage.tsx";
import DocumentFoldersPage from "@/pages/docs/DocumentFoldersPage.tsx";
import EsignRequestsPage from "@/pages/esign/EsignRequestsPage.tsx";
import EsignMarkupPage from "@/pages/esign/EsignMarkupPage.tsx";
import { RouteConfig } from "@/routes/types/route.types.ts";
import { ApiPermission } from "@/types/role.types.ts";
import { ApiFeatureType } from "@/types/subscription.types.ts";

export const docsRoutes: RouteConfig[] = [
  {
    path: "docs",
    element: <DocsPage />,
  },
  {
    path: "docs/esign-requests",
    element: <EsignRequestsPage />,
    planFeature: ApiFeatureType.esign,
    allOfPermissions: [ApiPermission.esign_request],
  },
  {
    path: "docs/settings",
    element: <DocumentFoldersPage />,
    allOfPermissions: [ApiPermission.settings_document_folders],
  },
  {
    path: "docs/documents/:documentId/markup",
    element: <EsignMarkupPage />,
    isFullScreen: true,
    planFeature: ApiFeatureType.esign,
    anyOfPermissions: [ApiPermission.esign_manage_templates, ApiPermission.esign_request],
  },
];
